import { t } from '../i18n';
import { Menu, X } from 'lucide-react';

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const MobileMenuButton = ({ isOpen, onClick }: MobileMenuButtonProps) => {
  return (
    <button
      onClick={onClick}
      className="fixed top-4 right-4 z-50 p-3 rounded-full bg-card border border-foreground/10 shadow-lg text-foreground lg:hidden transition-all duration-200 hover:bg-card-hover"
      aria-label={isOpen ? t("Close menu") : t("Open menu")}
    >
      {isOpen ? (
        <X className="w-6 h-6" />
      ) : (
        <Menu className="w-6 h-6" />
      )}
    </button>
  );
};

export default MobileMenuButton;
